import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import Image from 'next/image'
import useScrollScale from '@/hooks/tools/use-scroll-scale'
import TitleAndDesc from '@/components/standard/title-and-desc'

const TagItem: FC<{
  title?: string
  desc?: string
  icon?: string
}> = ({ title, desc, icon }) => {
  return (
    <div className={clsx('flex flex-col gap-1', 'laptop:gap-2')}>
      <h2 className={clsx('text-28 font-bold flex', 'laptop:text-48', 'flex items-center', 'text-fc-primary')}>
        <span>{title}</span>
        {icon && (
          <div className={clsx('relative', 'w-6 h-6 laptop:w-12 laptop:h-12')}>
            <Image src={icon} alt={desc} layout="fill" />
          </div>
        )}
      </h2>
      <p className={clsx('text-14', 'laptop:text-16', 'text-fc-secondary')}>{desc}</p>
    </div>
  )
}

type Section12Type = {
  title: string
  desc: string
  tagGroup?: Array<{ title: string; desc: string }>
  mediaUrl: string
  theme?: string
}

const Section12: FC<Section12Type> = ({ theme, title, desc, tagGroup = [], mediaUrl }) => {
  const containerRef = useScrollScale({
    targetSelector: '.target-section12',
  })

  return (
    <div className={clsx('w-full h-fit', 'py-15 laptop:py-30', `pd-theme-${theme}`, 'bg-anti-blk')}>
      <div className={clsx('')}>
        {(title || desc || (tagGroup && tagGroup?.length > 0)) && (
          <>
            <TitleAndDesc title={title} desc={desc} titleTag="h2" />
            {/* <div className={clsx('mb-8 max-w-300 mx-auto laptop:mb-64px', 'px-6 laptop:px-0')}>
              <div
                className={clsx(
                  'grid grid-cols-2 laptop:flex justify-between',
                  'gap-y-8 laptop:gap-y-16',
                  'mt-8 laptop:mt-16',
                  'text-fc-primary'
                )}
              >
                {tagGroup?.length > 0 &&
                  tagGroup.map((item) => {
                    return <TagItem key={item.title} {...item} />
                  })}
              </div>
            </div> */}
          </>
        )}

        <div className="w-full laptop:max-w-300 mx-auto" ref={containerRef}>
          <div className={clsx(`w-full h-250px laptop:h-fit overflow-hidden`)} style={{ aspectRatio: '2/1' }}>
            <PdMedia src={mediaUrl || ''} mask={false} className={`target-section12 scale-150`} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section12
